import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setPromotionalBannersWidgetDeviationPageBanner = createAction(
  `${reduxKey}.SET_PROMOTIONALBANNERS_WIDGET_DEVIATION_PAGE_BANNER`,
  (deviationPageBanner: boolean) => ({ deviationPageBanner })
);

export const setPromotionalBannersWidgetProfileCoverBanner = createAction(
  `${reduxKey}.SET_PROMOTIONALBANNERS_WIDGET_PROFILE_COVER_BANNER`,
  (profileCoverBanner: boolean) => ({ profileCoverBanner })
);

export const savePromotionalBanners = createAction(
  `${reduxKey}.SAVE_PROMOTIONAL_BANNERS`,
  () => ({})
);

export const savePromotionalBannersSuccess = createAction(
  `${reduxKey}.SAVE_PROMOTIONAL_BANNERS_SUCCESS`,
  () => ({})
);

export const savePromotionalBannersFailure = createAction(
  `${reduxKey}.SAVE_PROMOTIONAL_BANNERS_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
